<template>
  <section class="virtual-visit" data-section="virtual-visit" data-light-menu="true">
    <div class="background__virtual-visit"></div>
    <h2 v-if="content.title" class="virtual-visit__content__title" v-reveal="{ delay: 350 }">
      {{ content.title }}
    </h2>
    <div class="virtual-visit__content">
      <div class="virtual-visit__content__info">
        <RawHtml
          v-if="content.description"
          :html="content.description"
          v-reveal="{ delay: 450 }"
          class="virtual-visit__content__description"
        >
        </RawHtml>
        <ul class="virtual-visit__content__locations-list">
          <template v-if="!mq.mdPlus">
            <VRLocationCard
              v-for="location in content?.cards"
              :key="location.flexKey"
              :content="location"
              @click="setIframeSrc(location.link)"
            />
          </template>
          <template v-else>
            <Transition name="fade" mode="out-in">
              <VRLocationCard
                v-if="activeCard"
                :key="activeKey"
                :content="activeCard"
                @click="setIframeSrc(activeCard.link)"
              />
            </Transition>
          </template>
        </ul>
        <div v-if="content?.cards.length > 1" class="virtual-visit__content__locations__buttons">
          <button class="button -square carousel__left" @click="changeLocation(false)">
            <Icon id="arrow" />
          </button>
          <button class="button -square" @click="changeLocation">
            <Icon id="arrow" />
          </button>
        </div>
      </div>
      <iframe
        :src="iframeSrc"
        class="virtual-visit__iframe"
        allowfullscreen="true"
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </section>
</template>
<script>
import VRLocationCard from '@/components/cards/VRLocationCard.vue'
import Icon from '@/components/global/Icon.vue'
import RawHtml from '@/components/global/RawHtml.vue'
export default {
  name: 'VirtualVisitSection',
  components: { VRLocationCard, Icon, RawHtml },
  inject: ['mq'],
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iframeSrc: import.meta.env.VITE_APP_GEO_TOUR_URL,
      activeIndex: 0,
    }
  },
  computed: {
    locationCount() {
      return this.content?.cards?.length || 0
    },
    activeCard() {
      return this.content?.cards?.[this.activeIndex] || null
    },
    activeKey() {
      return this.activeCard?.flexKey || `virtual-location-${this.activeIndex}`
    },
  },
  methods: {
    setIframeSrc(newSrc) {
      this.iframeSrc = newSrc
    },
    changeLocation(navigateRight = true) {
      this.activeIndex =
        (navigateRight ? ++this.activeIndex : --this.activeIndex) % this.locationCount
      if (this.activeIndex < 0) this.activeIndex = this.locationCount - 1
    },
  },
}
</script>
